module.exports = __webpack_public_path__ + "img/_icon_history.255a6ee8.svg";